// extracted by mini-css-extract-plugin
export default {"root":"DataGridRowItem_root__RE9uV"};